import { merchantApi } from '@/config/axios'

// ========== 商家端财务管理 API ==========

// 钱包信息
export const getWallet = () => {
  return merchantApi.get({ url: '/merchant-api/finance/wallet' })
}

// 账单分页
export const getBillPage = (params: any) => {
  return merchantApi.get({ url: '/merchant-api/finance/bill/page', params })
}

// 提现申请
export const applyWithdraw = (data: any) => {
  return merchantApi.post({ url: '/merchant-api/finance/withdraw/apply', data })
}

// 提现记录分页
export const getWithdrawPage = (params: any) => {
  return merchantApi.get({ url: '/merchant-api/finance/withdraw/page', params })
}

// 提现详情
export const getWithdraw = (id: number) => {
  return merchantApi.get({ url: `/merchant-api/finance/withdraw/get?id=${id}` })
}
